import { colors } from '../../../../../Components/consts'
import { styled } from '@mui/system'

export const ExplainersCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
  margin: theme.spacing(2),
  '& ul': {
    margin: theme.spacing(0, 0, 2, 0),
    listStyle: 'disc',
    paddingLeft: theme.spacing(2),
    color: colors.gray.gray20,
    lineHeight: '1.5',
  },
}))